import { Component, Input, OnInit } from '@angular/core';
import { DatetimeChangeEventDetail } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DismissRolesEnum } from '@shared/enums';

@Component({
    selector: 'anp-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    standalone: false
})
export class TimePickerComponent implements OnInit {
  @Input() public label;

  public time: number;
  public roles = DismissRolesEnum;

  private modal: HTMLIonModalElement;

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.time = this.getTimeMinutes();
    if (!this.label) this.label = this.translateService.instant('COMPONENTS.time-picker.default-label');
  }

  public updateTime(event: Event): void {
    const isoStr = ((event as unknown as CustomEvent).detail as unknown as DatetimeChangeEventDetail).value;
    //this.time = this.getTimeMinutes(isoStr);
  }

  public async dismiss(role: DismissRolesEnum): Promise<void> {
    await this.modal.dismiss(this.time, role);
  }

  /**
   * Convierte una ISO String a los minutos correspondientes
   * @param isoString una ISO string segun el estandar de ISO 8601
   */
  public getTimeMinutes(isoString?: string): number {
    const isoStr = isoString ?? new Date().toISOString();
    const timeString = new Date(isoStr).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    const [hours, minutes] = timeString.split(':');
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  }
}
